import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import * as rx from "rxjs";
import { CrearContrarecibosForm, Props as FormProps } from "./form";

export interface Props {
    /**Folios de las guias seleccionadas para los contrarecibos*/
    value: string[];
    onChange: (x: string[]) => void;
}
export interface State {
    filtro: models.FiltroGuiasContrarecibos;
}

let sugerenciaAnterior: any;
/**Componente de selección */
export class CrearContrarecibosEdit extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);

        this.state = { filtro: {
        } };
    }

    onSetFiltro = (x: models.FiltroGuiasContrarecibos) => {
        this.setState({ filtro: x });
    }

    filtro = (x: State) => x.filtro;
    sugerencia = createSelectorRx(this.filtro, filtro => {
        if(filtro.IdClientePaga == null && filtro.IdSucursalCobranza == null)  {
            return rx.Observable.from([[]]);
        } else {
            return observeResource(resources.Cobranza2.ObtenerGuiasFacturar, filtro)
        }
    });

    render() {
        const sugerencia = this.sugerencia(this.state);

        let comparacion = sugerenciaAnterior == sugerencia;
        sugerenciaAnterior = sugerencia;
        return <CrearContrarecibosForm
            filtro={this.state.filtro}
            onFiltroChange={this.onSetFiltro}
            onChange={this.props.onChange}
            value={this.props.value}
            sugerencia={sugerencia}
        />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/generarcontrarecibos/edit.tsx